<script setup lang="ts">
/**
 * App Layout Component
 *
 * Main application layout with sidebar and header.
 * Fetches pending product-request notifications on mount (login / page refresh).
 */
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import AppHeader from './AppHeader.vue';
import AppSidebar from './AppSidebar.vue';
import Breadcrumbs from '@/shared/components/navigation/BreadcrumbsComponent.vue';
import AppFooter from './AppFooter.vue';
import { useNotificationsStore } from '@/stores/notifications.store';
import { useUIStore } from '@/stores';

const route = useRoute();
const uiStore = useUIStore();
const notificationsStore = useNotificationsStore();

onMounted(() => {
  notificationsStore.loadPendingRequests();
});
</script>

<template>
  <div>
    <AppHeader />
    <!-- <AppSidebar /> -->

    <div class="lg:pl-0">
      <AppSidebar />
    </div>
    <div
      class="h-screen flex flex-col transition-[padding-left] duration-300"
      :class="uiStore.sidebarCollapsed ? 'lg:pl-[60px]' : 'lg:pl-56'"
    >
      <main class="mt-4 flex-1 overflow-hidden">
        <div class="h-full flex flex-col px-4 sm:px-6 lg:px-4 pb-14">
          <!-- Breadcrumbs — fixed, does not scroll -->
          <div
            v-if="route.path !== '/'"
            class="p-4 shrink-0"
          >
            <Breadcrumbs />
          </div>

          <!-- Page content — only this area scrolls -->
          <div class="flex-1 min-h-0 overflow-y-auto scrollbar-hide">
            <RouterView />
          </div>
        </div>
      </main>
    </div>
    <AppFooter />
  </div>
</template>
